import {
  LocalColumnConfig,
  LocalTableConfigType,
} from 'app/modules/localTableSettings/models';
import { LOCAL_TABLE_SETTINGS_SLICE_NAME } from 'app/modules/localTableSettings/slice';

const DEFAULT_COLUMN_CONFIG = [];

export const selectLocalTableConfig =
  (type: LocalTableConfigType) =>
  (state: RootState): LocalColumnConfig[] =>
    state[LOCAL_TABLE_SETTINGS_SLICE_NAME][type] ?? DEFAULT_COLUMN_CONFIG;
